import React from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/icon';

import { CustomizedButton, CustomizedTooltip } from 'components/common';

export const CreateRiskRegisterButton = () => {
    const { pathname } = useLocation();
    const history = useHistory();

    const handleAddTask = () => {
        history.push(`${pathname}/create`);
    };

    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Top}
            tooltipContent={`Add Risk`}
            triggerElement={
                <CustomizedButton
                    startIcon={<Icon name={'plus-icon'} size="1.5rem" color={'#ffffff'} />}
                    color={'primary'}
                    onClick={handleAddTask}
                >
                    Add New Risk
                </CustomizedButton>
            }
        />
    );
};
